import script from "./floatButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./floatButton.vue?vue&type=script&setup=true&lang=ts"

import "./floatButton.vue?vue&type=style&index=0&id=350f68b4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-350f68b4"]])

export default __exports__